// @flow
import React, { useContext, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import Navbar from '@uniiverse/library/components/navbar';
import Footer from '@uniiverse/library/components/footer';
import LocaleContext from 'context/locale-context';
import AccountNavbar from '../../../components/account-navbar';
import { OrganizationContext } from '../../../components/organization-select/withOrganization';
import { LOCALES } from '../../../../src/lib/locale';
import { withFilters, FiltersContext } from '../../../components/reports/withFilters';
import { locale } from '../locale.js';
import OrdersTable from '../../../components/add-ons/orders-table';
import styles from '../styles-module.css';
import { trackAmplitude } from '../../../lib/analytics';

import {
  ORDERS_PAGE,
  ADD_ONS_PAGE
} from '../consts';

const AddOnOrders = injectIntl(({intl}) => {

  const localeContext = useContext(LocaleContext);
  const { selectedMembership } = useContext(OrganizationContext);
  const [hostId, setHostId] = useState(selectedMembership.owner.id || null);
  const { currencies } = useContext(FiltersContext);

  const { user } = localeContext;

  useEffect(() => {
    setHostId(selectedMembership?.owner?.id || user?.id);
  }, [selectedMembership, hostId, user]);

  const handleTrackAmplitude = (eventName, eventData) => {
    trackAmplitude({
      eventName,
      eventData,
      user
    });
  }

  return <>
     <main>
        <Navbar user={localeContext.user}/>
          <AccountNavbar
            currentUser={localeContext.user}
            currencies={currencies}
          />
          <section className={styles.addOns}>
            <div className={styles.addOnsTitle}>{intl.formatMessage(locale.title)}</div>
            <div className={styles.addOnsNavigation}>
              <a href={ADD_ONS_PAGE}>{intl.formatMessage(locale.title)}</a>
              <a href={ORDERS_PAGE} className={styles.active}>{intl.formatMessage(locale.orders)}</a>
            </div>
            <OrdersTable
              intl={intl}
              hostId={hostId}
              trackAmplitude={handleTrackAmplitude}
            />
          </section>
        <Footer
          switchLocale={localeContext.switchLocale}
          locale={localeContext.locale}
          locales={LOCALES}
        />
       </main>
  </>
});

export default withFilters(AddOnOrders);
